import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AccessControlValidationErrors } from '../../typings';
import { WelcomeDialogComponent } from '../components/welcome-dialog/welcome-dialog.component';
import { SessionService } from './session.service';
import { MatDialog } from '@angular/material/dialog';
import { SpinnerMessageService } from './spinner-message.service';
import { LogoutService } from './logout.service';

@Injectable()
export class ErrorDialogService {
     constructor(
          private loader: NgxSpinnerService,
          private session: SessionService,
          private spinnerMessage: SpinnerMessageService,
          private logoutService: LogoutService,
          private dialog: MatDialog
     ) {}

     private _run(sessionData, error) {
          this.session.clear();
          this.dialog.closeAll();
          this.dialog
               .open(WelcomeDialogComponent, {
                    closeOnNavigation: true,
                    panelClass: 'dialog--no-padding',
                    data: {
                         session: sessionData,
                         error,
                    },
               })
               .afterOpened()
               .subscribe(() => this.loader.hide());
     }

     async openErrorDialog(sessionData, error: AccessControlValidationErrors) {
          try {
               let res = await this.logoutService.run();
               if (res.ok) {
                    this._run(sessionData, error);
               }
          } catch (err) {
               this.loader.hide();
               this.spinnerMessage.reset();
               console.error('Unable to open error dialog: ' + err.message);
          }
     }
}
